// src/utility/shareRelease.js
import { shareRelease } from "../Services";

export const buildShareBody = (event, to, shareLink) => ({
  by: sessionStorage.getItem("email") || "",
  name: sessionStorage.getItem("username") || "",
  to,
  release_id: event?.release_id,
  title: event?.title || event?.release_title,
  service: event?.vendor_service,
  release_link: shareLink,
});

export async function shareReleaseData(event, to, shareLink) {
  const body = buildShareBody(event, to, shareLink);
  return shareRelease(body);
}
